export default {"src":"/_next/static/media/female-founded.5c19517f.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};